export default class Dropdown {

  constructor(el) {
    this.el = el;
    this.isOpen = false;

    this.select = this.el.querySelector('select');
    if (!this.select) {
      return;
    }

    this.el.addEventListener('click', this.toggle.bind(this));

    document.addEventListener('click', (e) => {
      if (!this.el.contains(e.target) && this.isOpen) {
        this.toggle();
      }
    });

    const options = this.el.querySelectorAll('.option');
    options.forEach(option => {
      option.addEventListener('click', (e) => {
        e.stopPropagation();
        const value = option.getAttribute('data-value');
        this.select.value = value;
        this.select.dispatchEvent(new Event('change'));
        this.toggle();
      });
    });
  }

  toggle() {
    this.isOpen = !this.isOpen;
    const options = this.el.querySelector('.options');
    if (this.isOpen) {
      options.classList.add('is-open');
    } else {
      options.classList.remove('is-open');
    }
  }

}

